module.exports = __webpack_public_path__ + "static/media/user-ninja.124e3815.svg";